module.exports = __webpack_public_path__ + "media/images/misused-sample-1-6197b448959cdc69f4032f2c78214bc4.png";